module.exports = __webpack_public_path__ + "static/maxima-telecom-screen-2-7f1c5428906e511da0ef1b2a695f4ea0.png";